module.exports = __webpack_public_path__ + "static/img/guidance111.e2e11eaf.png";